function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, mod) {
  var blacklist = mod.blacklist;
  var whitelist = mod.whitelist;
  var node_publicKey = mod.publicKey;
  var time_now = Date.now();
  var html = "\n  <!DOCTYPE html>\n  <html data-theme=\"dark\">\n    <head>\n      <meta charset=\"utf-8\">\n      <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n      <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n      <meta name=\"description\" content=\"\">\n      <meta name=\"author\" content=\"\">\n      <title>Saito Modtools</title>\n      <link rel=\"stylesheet\" type=\"text/css\" href=\"/saito/lib/jsonTree/jsonTree.css\" />\n      <link rel=\"stylesheet\" href=\"/saito/lib/font-awesome-6/css/all.css\" type=\"text/css\" media=\"screen\">\n      <script src=\"/saito/lib/jsonTree/jsonTree.js\"></script>\n      <link rel=\"icon\" sizes=\"192x192\" href=\"/saito/img/touch/pwa-192x192.png\">\n      <link rel=\"apple-touch-icon\" sizes=\"192x192\" href=\"/saito/img/touch/pwa-192x192.png\">\n      <link rel=\"icon\" sizes=\"512x512\" href=\"/saito/img/touch/pwa-512x512.png\">\n      <link rel=\"apple-touch-icon\" sizes=\"512x512\" href=\"/saito/img/touch/pwa-512x512.png\"></link>\n      <link rel=\"stylesheet\" href=\"/saito/saito.css?v=".concat(app.build_number, "\" type=\"text/css\" >\n      <link rel=\"stylesheet\" href=\"/modtools/style.css?v=").concat(app.build_number, "\" type=\"text/css\" >\n\n    </head>\n<body>\n\n\n    <div class=\"modtools-main-container hide-scrollbar\" id=\"modtools-main-container\">\n      <div class=\"saito-module-details-box\">\n        <div class=\"saito-module-title\">Modtools</div>\n        <div class=\"saito-module-description\">Module for managing and customizing wallet and application moderation tools</div>\n      </div>\n      \n\n    <div class=\"modtools-container\">\n      <div class=\"modtools-container-title\">Node</div>\n      <div class=\"saito-address treated\" data-id=\"").concat(node_publicKey, "\">\n        ").concat(node_publicKey, "\n      </div>\n      <div class=\"modtools-icon-holder\"><i id=\"pw-lock\" class=\"fa-solid fa-lock\"></i></div>\n    </div>\n\n\n    <div class=\"modtools-container\">\n      <div class=\"modtools-container-header\">\n        <div class=\"modtools-container-title\">Blacklisted</div>\n    ");
  if (blacklist.length > 0) {
    html += "<div class=\"saito-button-primary\" id=\"unblacklist\">Remove</div>";
  }
  html += '</div>';
  if (blacklist.length > 0) {
    for (var i = 0; i < blacklist.length; i++) {
      var added = new Date(blacklist[i].created_at);
      var dateString = added.toUTCString();
      var expString = 'forever';
      if (blacklist[i].duration > 0) {
        var timeleft = blacklist[i].created_at + blacklist[i].duration - time_now;
        if (timeleft < 0) {
          expString = 'expired';
        } else {
          var duration = app.browser.formatTime(timeleft);
          expString = "".concat(duration.hours, "H : ").concat(duration.minutes, "M : ").concat(duration.seconds, "S");
        }
      }
      var publicKey = blacklist[i].publicKey;
      var identicon = app.keychain.returnIdenticon(publicKey);
      html += "\n                <div class=\"modtools-contact\">\n                    <div class=\"modtools-contact-details\">\n                      <div class=\"saito-identicon-box\">\n                        <img class=\"saito-identicon\" src=\"".concat(identicon, "\">\n                      </div>\n                      <div class=\"saito-address treated\" data-id=\"").concat(publicKey, "\">").concat(app.keychain.returnIdentifierByPublicKey(publicKey, true), "</div>\n                    </div>\n                    <div class=\"modtools-contact-date\">").concat(dateString, "</div>\n                    <div class=\"modtools-contact-date\">").concat(expString, "</div>\n                    <div class=\"saito-address treated\" data-id=\"").concat(blacklist[i].moderator, "\">").concat(app.keychain.returnIdentifierByPublicKey(blacklist[i].moderator, true), "</div>\n                </div>\n               ");
    }
  } else {
    html += "\n          <div>No contacts in blacklist</div>\n        ";
  }
  html += "\n        </div>\n    ";
  html += "\n        <div class=\"modtools-container\" id=\"modtools-whitelist\">\n          <div class=\"modtools-container-header\">\n            <div class=\"modtools-container-title\">Whitelisted</div>\n      ";
  if (whitelist.length > 0) {
    html += "<div class=\"saito-button-primary\" id=\"unwhitelist\">Remove</div>";
  }
  html += "<div class=\"saito-button-primary\" id=\"whitelist\">Add</div></div>";
  if (whitelist.length > 0) {
    for (var _i = 0; _i < whitelist.length; _i++) {
      var added = new Date(whitelist[_i].created_at);
      var _dateString = added.toUTCString();
      var _expString = 'forever';
      if (whitelist[_i].duration > 0) {
        var _timeleft = whitelist[_i].created_at + whitelist[_i].duration - time_now;
        if (_timeleft < 0) {
          _expString = 'expired';
        } else {
          var _duration = app.browser.formatTime(_timeleft);
          _expString = "".concat(_duration.hours, "H : ").concat(_duration.minutes, "M : ").concat(_duration.seconds, "S");
        }
      }
      var _publicKey = whitelist[_i].publicKey;
      var _identicon = app.keychain.returnIdenticon(_publicKey);
      html += "\n                <div class=\"modtools-contact\">\n                    <div class=\"modtools-contact-details\">\n                      <div class=\"saito-identicon-box\">\n                        <img class=\"saito-identicon\" src=\"".concat(_identicon, "\">\n                      </div>\n                      <div class=\"saito-address treated\" data-id=\"").concat(_publicKey, "\">").concat(app.keychain.returnIdentifierByPublicKey(_publicKey, true), "</div>\n                    </div>\n                    <div class=\"modtools-contact-date\">").concat(_dateString, "</div>\n                    <div class=\"modtools-contact-date\">").concat(_expString, "</div>\n                    <div class=\"saito-address treated\" data-id=\"").concat(whitelist[_i].moderator, "\">").concat(app.keychain.returnIdentifierByPublicKey(whitelist[_i].moderator, true), "</div>\n                  </div>\n               ");
    }
  } else {
    html += "\n          <div>No contacts in whitelist</div>\n        ";
  }
  html += "\n    </div>\n</body>\n\n  <script type=\"text/javascript\">\n    var blacklist = [];\n    var whitelist = [];";
  var _iterator = _createForOfIteratorHelper(blacklist),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var b = _step.value;
      html += " blacklist.push(`".concat(b.publicKey, "`);");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(whitelist),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var w = _step2.value;
      html += " whitelist.push(`".concat(w.publicKey, "`);");
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  html += "</script>\n\n<script type=\"text/javascript\" src=\"/saito/saito.js?build=".concat(app.build_number, "\"></script>\n</html>");
  return html;
};